import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { Menu, UnstyledButton } from "@mantine/core";
import { faLink } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { useEmrContext } from "@/hooks/emr-context";
import { usePatientStudies } from "@/hooks/studies";
import { useLinkStudyToReport } from "@/hooks/report";
import { showSuccessToast, showErrorToast } from "@/components/toast";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { formatDate } from "@/utils/format";
import { DicomGlyph } from "./dicom-glyph";
/** Muted DICOM badge with a dropdown of the patient's studies to link to an unlinked report. */
export function DicomLinkMenu(_ref) {
  var _studiesQuery$data$st, _studiesQuery$data;
  var reportId = _ref.reportId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    workspaceId = _useEmrContext.workspaceId,
    patientUid = _useEmrContext.patientUid;
  var queryClient = useQueryClient();
  var studiesQuery = usePatientStudies(patientUid);
  var link = useLinkStudyToReport(workspaceId, patientUid);
  var studies = (_studiesQuery$data$st = (_studiesQuery$data = studiesQuery.data) === null || _studiesQuery$data === void 0 ? void 0 : _studiesQuery$data.studies) !== null && _studiesQuery$data$st !== void 0 ? _studiesQuery$data$st : [];
  var label = t("link_dicom_study", {
    defaultValue: "Link a DICOM study"
  });
  var handleLink = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(study) {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trackEvent(ANALYTICS_EVENTS.REPORT_LINK_STUDY, {
              value: study.accession_number
            });
            _context.p = 1;
            _context.n = 2;
            return link.mutateAsync({
              reportId: Number(reportId),
              accessionNumber: study.accession_number
            });
          case 2:
            showSuccessToast(t("study_linked_to_report", {
              defaultValue: "Study linked to report"
            }));
            void queryClient.invalidateQueries(["patient-reports", patientUid]);
            void queryClient.invalidateQueries(["patient-studies", patientUid]);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            showErrorToast(t("error_linking_study", {
              defaultValue: "Could not link the study"
            }));
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleLink(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var studyLabel = function studyLabel(study) {
    var _study$series;
    var name = study.study_description || ((_study$series = study.series) === null || _study$series === void 0 || (_study$series = _study$series[0]) === null || _study$series === void 0 ? void 0 : _study$series.modality) || t("study", {
      defaultValue: "Study"
    });
    return "".concat(name, " \xB7 ").concat(formatDate(study.created_at));
  };
  return /*#__PURE__*/React.createElement(Menu, {
    position: "bottom-end",
    offset: 6,
    width: 240,
    shadow: "md",
    withinPortal: true,
    closeOnItemClick: true
  }, /*#__PURE__*/React.createElement(Menu.Target, null, /*#__PURE__*/React.createElement(UnstyledButton, {
    type: "button",
    "data-testid": "report-link-study-".concat(reportId),
    "aria-label": label,
    title: label,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    className: "inline-flex flex-shrink-0 items-center gap-1 rounded-sds-100 border border-gray-300 bg-gray-50 px-1.5 py-0.5 text-style-label-caps text-gray-400 hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-500 dark:hover:bg-gray-700"
  }, /*#__PURE__*/React.createElement(DicomGlyph, {
    className: "h-2.5 w-2.5 flex-shrink-0"
  }), t("dicom", {
    defaultValue: "DICOM"
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faLink,
    className: "h-2.5 w-2.5 flex-shrink-0"
  }))), /*#__PURE__*/React.createElement(Menu.Dropdown, {
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }, studies.length === 0 ? /*#__PURE__*/React.createElement(Menu.Item, {
    disabled: true,
    "data-testid": "report-link-study-empty"
  }, t("no_study_available", {
    defaultValue: "No study available"
  })) : studies.map(function (study) {
    var _study$radiologist_re;
    return /*#__PURE__*/React.createElement(Menu.Item, {
      key: study.accession_number,
      "data-testid": "report-link-study-option-".concat(study.accession_number),
      disabled: Boolean((_study$radiologist_re = study.radiologist_report) === null || _study$radiologist_re === void 0 ? void 0 : _study$radiologist_re.report),
      onClick: function onClick() {
        return void handleLink(study);
      }
    }, studyLabel(study));
  })));
}